import { CORE_AXIOS, type Http } from '@/core'
import { container } from 'tsyringe'
import baseAxios from "axios"
import type { CategoriesMenusState, CategoriesDetailArray, DesginShareTheme, categoriesDetailArray, categoriesMenusState, spusDetailState } from "../configure"

export const saveShareTheme = async (data: DesginShareTheme): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.post(`/v1/api/design_share/theme`, data)
}

export const deleteShareTheme = async (themeId: number): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.delete(`/v1/api/design_share/theme/${themeId}`)
}

export const updateShareTheme = async (themeId: number, data: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.put(`/v1/api/design_share/theme/${themeId}`, data)
}

export const fetchMaterialTag = async (): Promise<any> => {
  return await baseAxios.get('/admin/v1/api/dictionaries/materialTag')
}

export const updateShareThemeStatus = async (themeId: number, data: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.put(`/v1/api/design_share/theme/${themeId}/status`, data)
}

export const fetchShareThemeList = async (): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get(`/v1/api/design_share/theme`)
}

export const fetchShareTheme = async (themeId: number): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get(`/v1/api/design_share/theme/${themeId}`)
}

// 商品详情
export const fetchCustomSpu = async (id: number): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get(`/v1/api/pms/custom/spus/${id}`)
}

/** 获取产品种类接口 */
export async function categoriesTypeMenu(): Promise<CategoriesMenusState> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get<CategoriesMenusState>('/v1/api/pms/categories')
}

/** 根据产品种类,获取种类下的全部商品 */
export async function categoriesDetail(id: string): Promise<CategoriesDetailArray> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get<CategoriesDetailArray>("/v1/api/pms/categories/" + id + "/spus")
}

// 新增订单
export const addDssOrder = async (data: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.post("/v1/api/dss/order", data)
}

// 新增图片的使用
export const addUmsDssOrderItem = async (data: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.post("/v1/api/dss/order/customized_image", data)
}

// 查询微信支付是否存在
export const dssWxpayQuery = async (data: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get("/v1/api/dss/wxpay/query", data)
}

// 查询支付宝支付是否存在
export const dssAlipayQuery = async (data: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get("/v1/api/dss/alipay/query", data)
}

/** 根据产品种类,获取种类下的全部设计主题 */
export async function categoriesDssDetail(category_id: string, data?: any): Promise<void> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get(`/v1/api/dss/categories/${category_id}/theme`, data)
}
// 获取主题下的全部spu //
export async function getThemeCustomSpuData(theme_id: number): Promise<void> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get(`/v1/api/design_share/theme/${theme_id}/customSpu`)
}

export async function spusDetail(id: string): Promise<spusDetailState> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get("/v1/api/pms/spu/" + id + "/skus")
}

export async function spusComment(id: number, data: any): Promise<spusDetailState> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get("/v1/api/pms/spu/" + id + "/comment", data)
}
export async function spusCount(id: number): Promise<spusDetailState> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get("/v1/api/pms/spu/" + id + "/comment/count")
}
/** 根据产品种类,获取种类下的全部商品 */
export async function getSpuDetail(id: number, spu_id: number): Promise<categoriesDetailArray> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get<categoriesDetailArray>(`/v1/api/pms/categories/${id}/spus/${spu_id}`)
}

